import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const FrozenDragArea = ({track, freezeDragging}) => { 
    const onDrop = useCallback(() => {
        track.dragFreezeIntoColumn(freezeDragging);
    }, [freezeDragging]);

    if (track.frozenColumns.every(x => x.frozenSamplers.length === 0)) {
        return (<div></div>);
    }
    return (
        <div
          onDrop={onDrop}
          className="frozen-drag-area">
          <div className="text-drag">
            Drag Frozen Track Here
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      freezeDragging: state.freeze.freezeDragging,
      ... props.track.frozenColumns.map(
          x => x.frozenSamplers.length)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FrozenDragArea);
